import { Component, input } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicField } from '@shared/components/dynamic-form/models/field';

@Component({
  selector: 'app-yes-no-rating-field',
  imports: [TranslateModule],
  templateUrl: './yes-no-rating-field.component.html',
})
export class YesNoRatingFieldComponent {
  field = input.required<DynamicField>();
  form = input.required<FormGroup>();
  editable = input<boolean>(true);

  get formControl() {
    return this.form().get(this.field().key) as AbstractControl<number>;
  }

  get selectedValue(): number | null {
    const value = this.formControl?.value;

    return value === null || value === undefined || (value as unknown) === ''
      ? null
      : +value;
  }

  onChangeSelection(e) {
    const value = e.target.value;
    this.form().get(this.field().key)?.setValue(+value);
  }
}
